export const DEFAULT_TOTAL_COUNT_FIELD = "totalCount";

export const LAST_DAY_CLICKS_FIELDS = {
    clicks: "lastDayClicks",
    keyword: "lastDayKeyword",
    visibility: "lastDayVisibility",
    avgPosition: "lastDayAvgPos",
};

export const MAX_VALID_POSITION = 99.9;
